<template>
    <div ref="container">
        <a-modal 
            :title="title" 
            width="95%" 
            :visible="visible" 
            :confirmLoading="confirmLoading" 
            :maskStyle="{'top':'93px','left':'154px'}" 
            :maskClosable="false" 
            @ok="handleOk" 
            @cancel="handleCancel"
            @closeModal="closeModal" 
            cancelText="关闭" 
            style="top:50px;height: 90%;"
        >
            <a-list >
                <a-list-item v-for="(item, index) in listData" :key="index">
                    {{ item }}
                </a-list-item>
            </a-list>
            <a-pagination
                style="margin-top: 16px; text-align: right;"
                :current="pagination.current"
                :pageSize="pagination.pageSize"
                :total="pagination.total"
                @change="handlePaginationChange"
                showSizeChanger
                :pageSizeOptions="pagination.pageSizeOptions"
                :showTotal="pagination.showTotal"
            />
        </a-modal>
    </div>
</template>
<script>
import { getTraceEventCodes } from '@/api/api'
export default {
    name: 'CustomerModal',
    components: {},
    data () {
        return {
            title: '事件信息',
            visible: false, 
            detailVisible: false, 
            traceDetailVisible: false, 
            confirmLoading: false,
            originalImageVisible: false,
            originalImageUrl: '',
            processId: '',
            selectedItem: {},
            details: [],
            getId: '',
            model: {},
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
            },
            listData:[],
            pagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                    return `${range[0]}-${range[1]} 共 ${total} 条`;
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            }
        }
    },
    computed: {
        paginatedListData() {
            const { current, pageSize } = this.pagination;
            const start = (current - 1) * pageSize;
            const end = start + pageSize;
            return this.listData.slice(start, end);
        }
    },
    methods: {
        show(e){
            this.visible = true
            console.log(e,'e===================')
            this.getId = e.id
            this.getTraceList(e.id)
        },
        // 获取追溯事件码列表
        async getTraceList(id){
            this.listData = []
            const params = { 
                id: id,
                currentPage: this.pagination.current,
                pageSize: this.pagination.pageSize
            }
            const res = await getTraceEventCodes(params)
            if( res.code == 200 && res.success == true ){
                this.listData = res.result.list
                this.pagination.total = res.result.total
            } else {
                this.$message.error(res.message)
            }
        },
        handlePaginationChange(page, pageSize) {
            this.pagination.current = page;
            this.pagination.pageSize = pageSize;
            this.getTraceList(this.getId); // 重新获取数据
        },
        handleOk() {
          this.visible = false;
        },
        handleCancel(){
          this.visible = false;
        },
        closeModal(){
          this.visible = false;
        },
    }
}
</script>
<style lang="scss" scoped>
    .ant-pagination {
        display: block !important;
    }
</style>